import { PermissionGroup } from 'utils/user/types';
import { PageMap, PagePermission } from 'routes/types';
import { PageNotMappedError } from 'routes/errors';

export const getPage = (pagesMap: PageMap, permissionGroup: PermissionGroup) => {
  const { page, permission } = permissionGroup;

  const pagePermissions: PagePermission | undefined = pagesMap[page];

  // should be NotPermittedError, to prevent infinite loop where user has no permissions
  // but it could be a little surprise for business, to redirect user on 403 page..
  if (!permissionGroup.permission) throw PageNotMappedError();

  if (pagePermissions && permission in pagePermissions) {
    return pagePermissions[permission];
  }

  /*
    It should be NotFoundError or NotPermittedError,
    because we sometimes show links to pages that user dont have access to.

    Previously every not mapped page will redirect to default page,
    so I left this behavior, but @todo
   */
  throw PageNotMappedError();
};
